import api from "./axios";

const dashboardApi = {
  getStats: () => api.get("/admin/dashboard/stats"),
  getPopulationAnalysis: () => api.get("/admin/dashboard/population-analysis"),
  analyzePopulation: () =>
    api.post("/admin/dashboard/population-analysis/analyze"),
};

export default dashboardApi;
